<div class="progress-bar-loader-container">
	<div class="progress-bar-loader-bar" [class.error]="!!error"  [style.width]="progress + '%'"></div>
</div>
<div *ngIf="error" class="progress-bar-error" >
	{{error}}
</div>
